export default async function initBackToTop() {
  const element = document.querySelector('[data-js-module="back-to-top"]');

  if (element) {
    const { default: BackToTop } = await import(/* webpackChunkName: "back-to-top" */ './back-to-top');
    new BackToTop(element);
  }
}
